<template>
	<section>
		<loader :dialog="loading"></loader>
		<floating-alert
			:message="alertMessage"
			:show="alertShow"
			:type="alertType"
		></floating-alert>

		<!-- Toolbar -->
		<div class="fc-toolbar">
			<v-text-field
				v-model="search"
				label="Rechercher une catégorie..."
				prepend-inner-icon="mdi-magnify"
				outlined
				dense
				rounded
				hide-details
				class="fc-search"
			></v-text-field>
			<v-spacer></v-spacer>

			<!-- Create/Edit dialog -->
			<v-dialog v-model="dialog" max-width="480px">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						depressed
						rounded
						class="fc-add-btn"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon left small>mdi-plus</v-icon>
						Nouveau
					</v-btn>
				</template>
				<v-card rounded="xl" class="pa-2">
					<div class="fc-dialog-header">
						<div class="fc-icon-box">
							<v-icon size="18" color="white">mdi-folder-plus</v-icon>
						</div>
						<div>
							<p class="fc-dialog-title">{{ formTitle }}</p>
							<p class="fc-dialog-sub">Catégorie de repas</p>
						</div>
						<v-spacer></v-spacer>
						<v-btn icon small @click="close">
							<v-icon color="#6b7280">mdi-close</v-icon>
						</v-btn>
					</div>
					<v-divider></v-divider>
					<v-card-text class="pt-5">
						<v-text-field
							v-model="category.label"
							label="Nom de la catégorie"
							outlined
							dense
							rounded
							prepend-inner-icon="mdi-tag"
							hide-details
							class="mb-3"
						></v-text-field>
						<v-text-field
							v-model="category.description"
							label="Description"
							outlined
							dense
							rounded
							prepend-inner-icon="mdi-text"
							hide-details
						></v-text-field>
					</v-card-text>
					<v-card-actions class="pa-4 pt-2">
						<v-btn text color="error" rounded @click="close">Annuler</v-btn>
						<v-spacer></v-spacer>
						<v-btn depressed rounded class="fc-save-btn" @click="save">
							Enregistrer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!-- Delete dialog -->
			<v-dialog v-model="dialogDelete" max-width="440px">
				<v-card rounded="xl" class="pa-2">
					<div class="del-header">
						<div class="del-icon-box">
							<v-icon size="18" color="white">mdi-alert</v-icon>
						</div>
						<p class="del-title">Supprimer cette catégorie ?</p>
					</div>
					<v-card-text class="pb-1 text-body-2 grey--text text--darken-1">
						Cette action est irréversible.
					</v-card-text>
					<v-card-actions class="pa-4 pt-2">
						<v-btn text color="grey" rounded @click="closeDelete">Annuler</v-btn>
						<v-spacer></v-spacer>
						<v-btn depressed rounded class="del-confirm-btn" @click="deleteItemConfirm">
							Supprimer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>

		<card-loading v-if="skeletonLoader"></card-loading>
		<not-found v-else-if="categories.length === 0"></not-found>

		<v-row class="mt-3" v-else>
			<v-col
				sm="12" md="6" lg="4"
				v-for="category in filteredCategories"
				:key="category._id"
			>
				<v-card elevation="2" rounded="xl" class="fc-card">
					<div class="fc-card-img">
						<img
							src="../../../assets/image-categorie.jpg"
							alt="categorie"
							class="fc-cat-img"
						/>
					</div>
					<div class="fc-card-body">
						<p class="fc-cat-name">{{ category.label }}</p>
						<p class="fc-cat-desc">{{ category.description }}</p>
					</div>
					<v-divider></v-divider>
					<div class="fc-card-actions">
						<v-btn icon small @click="editItem(category)">
							<v-icon size="18" color="#1565c0">mdi-pencil</v-icon>
						</v-btn>
						<v-btn icon small @click="deleteItem(category)">
							<v-icon size="18" color="#c62828">mdi-delete</v-icon>
						</v-btn>
					</div>
				</v-card>
			</v-col>
		</v-row>
	</section>
</template>

<script>
import services from "@/services";
import Loader from "@/components/Loader.vue";
import NotFound from "@/components/Notfound.vue";
import CardLoading from "@/components/CardLoading.vue";
import FloatingAlert from "@/components/FloatingAlert.vue";
export default {
	components: { Loader, NotFound, CardLoading, FloatingAlert },
	data() {
		return {
			category: { label: "", description: "" },
			defaultItemCategory: { label: "", description: "" },
			loading: false,
			skeletonLoader: false,
			categories: [],
			editedIndex: -1,
			dialog: false,
			dialogDelete: false,
			alertMessage: "",
			alertShow: false,
			alertType: "",
			search: "",
		};
	},
	computed: {
		formTitle() {
			return this.editedIndex === -1
				? "Nouvelle catégorie"
				: "Modifier une catégorie";
		},
		filteredCategories() {
			return this.categories.filter((c) =>
				c.label.toLowerCase().includes(this.search.toLowerCase())
			);
		},
	},
	mounted() {
		this.initialize();
	},
	methods: {
		initialize() {
			this.categories = [];
			this.skeletonLoader = true;
			services
				.getFoodCategories()
				.then((results) => {
					this.skeletonLoader = false;
					this.categories = results.data.categories;
				})
				.catch((err) => {
					console.log(err);
					this.skeletonLoader = false;
				});
		},
		save() {
			if (this.editedIndex > -1) {
				this.loading = true;
				services
					.updateFoodCategory(this.category._id, this.category)
					.then(() => {
						Object.assign(this.categories[this.editedIndex], this.category);
						this.loading = false;
						this.close();
						this.initialize();
					})
					.catch((err) => {
						console.log(err);
						this.loading = false;
					});
			} else {
				this.loading = true;
				services
					.createFoodCategory(this.category)
					.then(() => {
						this.close();
						this.initialize();
						this.loading = false;
					})
					.catch((err) => {
						console.log(err);
						this.loading = false;
					});
			}
		},
		editItem(item) {
			this.editedIndex = this.categories.indexOf(item);
			this.category = Object.assign({}, item);
			this.dialog = true;
		},
		deleteItem(item) {
			this.editedIndex = this.categories.indexOf(item);
			this.category = Object.assign({}, item);
			this.dialogDelete = true;
		},
		deleteItemConfirm() {
			this.alertShow = false;
			this.loading = true;
			services
				.deleteFoodCategory(this.category._id)
				.then((response) => {
					this.categories.splice(this.editedIndex, 1);
					this.closeDelete();
					this.loading = false;
					this.alertMessage = response.message;
					this.alertShow = true;
					this.alertType = "green";
				})
				.catch(() => {
					this.loading = false;
					this.alertMessage = "Impossible de supprimer la catégorie";
					this.alertShow = true;
					this.alertType = "red";
				});
		},
		close() {
			this.dialog = false;
			this.$nextTick(() => {
				this.category = Object.assign({}, this.defaultItemCategory);
				this.editedIndex = -1;
			});
		},
		closeDelete() {
			this.dialogDelete = false;
			this.$nextTick(() => {
				this.category = Object.assign({}, this.defaultItemCategory);
				this.editedIndex = -1;
			});
		},
	},
};
</script>

<style scoped>
.fc-toolbar {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
	flex-wrap: wrap;
}
.fc-search {
	max-width: 320px;
}
.fc-add-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
.fc-dialog-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.fc-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.fc-dialog-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.fc-dialog-sub {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.fc-save-btn {
	background: #1565c0 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
.fc-card {
	overflow: hidden;
	font-family: Montserrat, sans-serif;
}
.fc-card-img {
	height: 120px;
	overflow: hidden;
}
.fc-cat-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.fc-card-body {
	padding: 14px 16px 10px;
}
.fc-cat-name {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 4px;
}
.fc-cat-desc {
	font-size: 0.75rem;
	color: #6b7280;
	margin: 0;
}
.fc-card-actions {
	display: flex;
	justify-content: flex-end;
	padding: 8px 12px;
	gap: 4px;
}
.del-header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px 20px 12px;
}
.del-icon-box {
	width: 34px;
	height: 34px;
	border-radius: 8px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
}
.del-title {
	font-size: 0.9rem;
	font-weight: 700;
	color: #111827;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.del-confirm-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
</style>

